/*! Coded by Didier. v1.0 activateAnchorOnScroll - Highlights the anchor link of the current section in view during scroll */
(function( $ ) {
    $.fn.activateAnchorOnScroll = function(options) {

        var currentOptions = $.extend({
            scrollableObj: window,
            activeCssClass: "active",
            activationAreaInPercentage: 20,
            historyStateType: 'replace' /* 'push' | null */
        }, options );

        // cache
        var anchorsByTargetId = {};
        // filter out links that may not be anchor links
        var anchorLinks = this.filter("[href*='#']");
        // find targets based on the links
        var targets = anchorLinks.map(function() {
            var currentAnchor = $(this);
            var targetIdToFind = currentAnchor.attr("href").slice(1);
            var target = $('#' + targetIdToFind);
            if (target.length == 1) {
                anchorsByTargetId[targetIdToFind] = currentAnchor;
                return target;
            } 
            else
            {
                if (target.length > 1) {
                    throw ("Multiple ids for one anchor link: " + targetIdToFind);
                }
                return null;
            }
        });

        // self explanatory
        var activeLink = null;

        /*
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY
        var browserCompatibleWindowScrollY = (function (){
            var supportPageOffset = window.pageXOffset !== undefined;
            var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");

            if (supportPageOffset) {
                return function() { return window.pageYOffset; }
            } else if (isCSS1Compat) {
                return function() { return document.documentElement.scrollTop; }
            } else {
                return function() { return document.body.scrollTop;  }           
            }
        })();*/

        var activateAnchorLink = function() {
            var viewportHeight = window.innerHeight;
            var areaHeight = viewportHeight * currentOptions.activationAreaInPercentage / 100;
            var areaStart = $(window).scrollTop();
            var areaStop = areaStart + areaHeight;

            function swapActiveLink(targetId) {
                var newUrl = '',
                    hash = '';

                if (activeLink != null && targetId != null && activeLink === anchorsByTargetId[targetId]) {
                    return;
                }

                if (activeLink != null) {
                    activeLink
                        .removeClass(currentOptions.activeCssClass)
                        .removeAttr('aria-current');
                }

                if (targetId != null) {
                    activeLink = anchorsByTargetId[targetId];
                    activeLink
                        .addClass(currentOptions.activeCssClass)
                        .attr('aria-current', 'true');
                    newUrl = activeLink.attr('href');
                    hash = '#' + newUrl;
                } else {
                    newUrl = window.location.pathname;
                }

                if (window.location.hash != hash) {
                    switch (currentOptions.historyStateType) {
                        case 'replace':
                            history.replaceState( {} , document.title, newUrl ); 
                            break;
                        case 'push':
                            history.pushState( {} , document.title, newUrl )
                            break;
                    }
                }
            }


            function getTargetId() {
                var targetId = null;

                // if we are close to the top ...
                if (areaStart < areaHeight / 2) {
                    return;
                }
 
                for (var i=0; i < targets.length; i++) {
                    var currentTarget = targets[i];
                    var targetScrollTop = currentTarget.offset().top;
    
                    if (targetScrollTop <= areaStop) {
                        targetId = currentTarget.attr("id");
                    } else {
                        break;
                    }
                }
                return targetId; 
            }
            
            // Find target in view
            var targetId = getTargetId();
            swapActiveLink(targetId);
        }

        activateAnchorLink();

        $(currentOptions.scrollableObj).scroll($.throttle(300, activateAnchorLink));

        return this;
    };
}(jQuery));